import React, { useContext, useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import "../../../assets/styles/select-car-variant.css";
import useGetVehicleInfo from "../../../store/selectors/get-vehicle-info";
import useGetToken from "../../../store/selectors/get-token";
import useStoreCarPlanQuote from "../../../store/actions/store-car-plan-quote";
import { getQuotes, startQuoteSession, getMoreQuotes, getOrder } from "../../../utils/backend";
import useStoreCarPlanList from "../../../store/actions/store-car-quote-list";

import { Image } from "primereact/image";
import useStoreVehicleInfo from "../../../store/actions/store-vehicle-info";
import useStoreCarAddOn from "../../../store/actions/store-car-add-on";
import useStoreCarAddOnSelection from "../../../store/actions/store-car-add-on-selection";
import useStoreCarQuoteList from "../../../store/actions/store-car-quote-list";
import { Dialog } from "primereact/dialog";
import prettyGirlCS from "../../../assets/images/pretty-girl-client-servicing.png";
import submitSuccessFul from "../../../assets/images/submit-successful.png";
import submitFail from "../../../assets/images/submit-failed.png";

import BottomMessagePopUp from "../../../components/BottomMessagePopUp";
import Loader2 from "../../../components/Loader2";

import { useTranslation } from 'react-i18next';
import { Checkbox } from "primereact/checkbox";
import { BMKContext } from "../../../components/Providers/BMK-provider";

const SelectCarVariant = () => {
  const { bmkData, setBMKData } = useContext(BMKContext);

  const navigate = useNavigate();
  const token = useGetToken();
  const setCarQuoteList = useStoreCarPlanList();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isMessageVisible, setIsMessageVisible] = useState(false);
  const clearCarPlanQuote = useStoreCarPlanQuote();

  const { t } = useTranslation();
  
	const [image, setImage] = useState(submitSuccessFul);
	const [dialogTitle, setDialogTitle] = useState("");
	const [respMessage, setRespMessage] = useState("");
	const [dialogOpen, setDialogOpen] = useState(false);
  const [isRecon, setIsRecon] = useState(()=> {
    const cachedVariant = localStorage.getItem("isReconditioned");
    return cachedVariant ? Boolean(cachedVariant) : false;
  });

  const handleCheckboxChange = (e) => {
    setIsRecon(e.checked);

    localStorage.setItem("isReconditioned", e.checked);
  }

	const clearVehicleInfo = useStoreVehicleInfo();
	const clearCarAddOn = useStoreCarAddOn();
	const clearCarAddOnSelection = useStoreCarAddOnSelection();
	const clearCarQuoteList = useStoreCarQuoteList();

	const vehicleInfo = useGetVehicleInfo();

	const showErrorMessage = (msg) => {
		setMessage(msg);
		setIsMessageVisible(true);
	};
  	
	const [selectedVariant, setSelectedVariant] = useState(null);

	const getVehicleInfo = useGetVehicleInfo();
	const variants = Array.isArray(getVehicleInfo?.variant_series)
		? getVehicleInfo.variant_series
		: [];

	const getDOBFromId = (idNo) => {
		const regex = /^(\d{6})\d{2}\d{3}(\d{1})$/;
		const match = idNo.match(regex);

		if (!match) {
			throw new Error("Invalid ID number format");
		}

		const birthDate = match[1];
		const genderDigit = parseInt(match[2], 10);

		const yearPrefix = birthDate.substring(0, 2);
		const month = birthDate.substring(2, 4);
		const day = birthDate.substring(4, 6);

		const currentYear = new Date().getFullYear();
		const currentCentury = Math.floor(currentYear / 100) * 100;

		let fullYear;

		if (parseInt(yearPrefix, 10) <= currentYear % 100) {
			fullYear = `20${yearPrefix}`;
		} else {
			fullYear = `19${yearPrefix}`;
		}

		const dob = new Date(`${fullYear}-${month}-${day}`);

		const age = currentYear - dob.getFullYear();

		if (isNaN(dob) || age < 0 || age > 120) {
			throw new Error("Invalid birth year in ID number");
		}

		const gender = genderDigit % 2 === 0 ? "F" : "M";

		const formattedDob = dob.toISOString().split("T")[0];

		return {
			dob: formattedDob,
			gender: gender,
			age: age,
		};
	};
  function formatDate(dateStr) {
		if (!dateStr) return "";
		const date = new Date(dateStr);

		if (isNaN(date)) return ""; // handle invalid date

		const day = String(date.getDate()).padStart(2, "0");

		const months = [
			"JAN",
			"FEB",
			"MAR",
			"APR",
			"MAY",
			"JUN",
			"JUL",
			"AUG",
			"SEP",
			"OCT",
			"NOV",
			"DEC",
		];

		const month = months[date.getMonth()];
		const year = date.getFullYear();

		return `${day}-${month}-${year}`;
	}

	function formatDate(dateStr) {
		if (!dateStr) return "";
		const date = new Date(dateStr);

		if (isNaN(date)) return ""; // handle invalid date

		const day = String(date.getDate()).padStart(2, "0");

		const months = [
			"JAN",
			"FEB",
			"MAR",
			"APR",
			"MAY",
			"JUN",
			"JUL",
			"AUG",
			"SEP",
			"OCT",
			"NOV",
			"DEC",
		];

		const month = months[date.getMonth()];
		const year = date.getFullYear();

		return `${day}-${month}-${year}`;
	}

  	function formatDate(dateStr) {
		if (!dateStr) return "";
		const date = new Date(dateStr);

		if (isNaN(date)) return ""; // handle invalid date

		const day = String(date.getDate()).padStart(2, "0");

		const months = [
			"JAN",
			"FEB",
			"MAR",
			"APR",
			"MAY",
			"JUN",
			"JUL",
			"AUG",
			"SEP",
			"OCT",
			"NOV",
			"DEC",
		];

		const month = months[date.getMonth()];
		const year = date.getFullYear();

		return `${day}-${month}-${year}`;
	}

	useEffect(() => {
		// Save selectedVariant to localStorage whenever it changes
		if (selectedVariant) {
			localStorage.setItem(
				"selectedVariant",
				JSON.stringify(selectedVariant)
			);
		}
	}, [selectedVariant]);

	const submitSelectedVariant1 = async (e) => {
		e.preventDefault();
    
		setLoading(true);

		let id_data;
		if (
			(vehicleInfo.id_type === "nric" ||
				vehicleInfo.id_type === "NRIC") &&
			vehicleInfo.id_no
		) {
			id_data = getDOBFromId(vehicleInfo.id_no);
		}

		let today = new Date();

		let issue_date = today.toISOString().split("T")[0];

		try {
			const payloads = {
				usecode: "",
				id_type: vehicleInfo.id_type,
				id_no: vehicleInfo.id_no,
				veh_reg_no: vehicleInfo.reg_no,
				postcode: vehicleInfo.postcode,
				veh_type: vehicleInfo.veh_type,
				//adddriver: [],
				policy_holder_name: vehicleInfo.ownership_type === "I" ? vehicleInfo.owner_name : vehicleInfo.companyName,
				ownership_type: vehicleInfo.ownership_type,
				gender_code: id_data?.gender || "",
				marital_code:
					id_data?.age >= 30 ? "M" : id_data?.age < 30 ? "S" : "O",
				dob: id_data?.dob || "",
				address1: "",
				address2: "",
				driveexp: "",
				occupation: "M36",
				cover_note_cate: "NWOO",
				issue_date: issue_date,
				inception_date: vehicleInfo.effective_date,
				expiry_date: vehicleInfo.expiry_date,
				class_code:
					vehicleInfo?.veh_type === "motorcycle" ? "01" : "02",
				vehicle_class_code:
					vehicleInfo?.veh_type === "motorcycle" ? "01" : "02",
				coverage_code: "CO",
				vehicle_use: "Q3",
				make_code: vehicleInfo?.vehicle_details?.make_code || "",
				model_code: vehicleInfo?.vehicle_details?.model_code || "",
				capacity: vehicleInfo?.vehicle_details?.veh_capacity || "",
				uom: "CC",
				make_year: vehicleInfo?.vehicle_details?.make_year || 0,
				seats: selectedVariant?.variant_seat || 0,
				ncd_from_code: "",
				engine_no: vehicleInfo?.vehicle_details?.engine_no || "",
				chassis_no: vehicleInfo?.vehicle_details?.chassis_no || "",
				nvic_code: selectedVariant?.variant_nvic || "",
				sum_insured: 0,
				email: "",
				hphoneno: "",
				company_name: vehicleInfo.companyName || "",
				variant_name: selectedVariant.variant_name || "",
				variant_transmission: selectedVariant.variant_transmission || "",
				variant_capacity: selectedVariant.variant_capacity || "",
				// msv_plan_code: "",
				// extra_coverages: [],
				agree_value: true,
				vehicle_model: getVehicleInfo?.vehicle
			};

			const getMoreQuotesDetails = await getMoreQuotes(token, payloads);
			if (getMoreQuotesDetails.success) {
				if (getMoreQuotesDetails.data && getMoreQuotesDetails.data.orderId) {
          // redirect to loading page
          clearCacheAndState();
          navigate(`/get-quote/loading-quotations?order_id=${getMoreQuotesDetails.data.orderId}`);
				}
			} else {
				setLoading(false);

				setImage(submitFail);
				setDialogTitle("Failed to Request");
				setRespMessage("Failed to request a new quotation, please try again later");
				setDialogOpen(true);
			}
		} catch (error) {
			showErrorMessage(error.message, "Something went wrong");
			setLoading(false);
		}
	};

	const clearCacheAndState = () => {
		// Clear Redux store
		clearVehicleInfo(null);
		clearCarAddOn(null);
		clearCarAddOnSelection(null);
		clearCarQuoteList(null);
		clearCarPlanQuote(null);
	
		// Clear localStorage
		const cacheKeys = [
		  "cachedAddress",
		  "drivers"
		];
		cacheKeys.forEach((key) => localStorage.removeItem(key));
	};

	const viewMyRequest = (e) => {
		e.preventDefault();
		window.ReactNativeWebView.postMessage('viewPolicies');
	};

	const handleBackButton = (e) => {
		e.preventDefault();
		window.ReactNativeWebView.postMessage('closeWebView');
	};

	const submitSelectedVariant = async (e) => {
		e.preventDefault();

		setLoading(true);
		if (!selectedVariant) {
			return;
		}

		let today = new Date();
		let issue_date = today.toISOString().split("T")[0];
		let id_data;

		if (
			(getVehicleInfo.id_type === "nric" ||
				getVehicleInfo.id_type === "NRIC") &&
			getVehicleInfo.id_no
		) {
			id_data = getDOBFromId(getVehicleInfo.id_no);
		}

		try {
			const payloads = {
				usecode: "",
				id_type: getVehicleInfo.id_type,
				id_no: getVehicleInfo.id_no,
				veh_reg_no: getVehicleInfo.reg_no,
				postcode: getVehicleInfo.postcode,
				veh_type: getVehicleInfo.veh_type,
				adddriver: [],
				policy_holder_name: getVehicleInfo.ownership_type === "I" ? getVehicleInfo.owner_name : getVehicleInfo.companyName,
				ownership_type: getVehicleInfo.ownership_type,
				gender_code: id_data?.gender || "",
				marital_code:
					id_data?.age >= 30 ? "M" : id_data?.age < 30 ? "S" : "O",
				dob: id_data?.dob || "",
				address1: "",
				address2: "",
				driveexp: "",
				occupation: "M36",
				cover_note_cate: "NWOO",
				issue_date: issue_date,
				inception_date: getVehicleInfo.effective_date,
				expiry_date: getVehicleInfo.expiry_date,
				class_code:
					getVehicleInfo?.veh_type === "motorcycle" ? "01" : "02",
				vehicle_class_code:
					getVehicleInfo?.veh_type === "motorcycle" ? "01" : "02",
				coverage_code: "CO",
				vehicle_use: "Q3",
				make_code: getVehicleInfo?.vehicle_details?.make_code || "",
				model_code: getVehicleInfo?.vehicle_details?.model_code || "",
				capacity: getVehicleInfo?.vehicle_details?.veh_capacity || "",
				uom: "CC",
				make_year: getVehicleInfo?.vehicle_details?.make_year || "",
				seats: selectedVariant?.variant_seat || "",
				ncd_from_code: "",
				engine_no: getVehicleInfo?.vehicle_details?.engine_no || "",
				chassis_no: getVehicleInfo?.vehicle_details?.chassis_no || "",
				nvic_code: selectedVariant?.variant_nvic || "",
				sum_insured: "",
				email: "",
				hphoneno: "",
				msv_plan_code: "",
				extra_coverages: [],
				// agree_value: true,
				no_of_driver: 2,
        		vehicle_variant: `${selectedVariant?.variant_name} ${selectedVariant?.variant_transmission} (${selectedVariant.variant_capacity}cc)`,
        isRecon: isRecon
			};

			// Progressive: start a quote session and hand its id to the plan page, which polls
			// it and renders insurer cards as they arrive — instead of blocking here on the
			// full ~11-insurer batch (the "app slow to retrieve quotes" complaint). Owner-
			// mismatch / not-yet-due are surfaced by the plan page's poll. Falls back to the
			// legacy one-shot batch when the session endpoint is unavailable (older backend).
			const started = await startQuoteSession(token, payloads);
			if (started && started.success && started.data && started.data.session_id) {
				try {
					localStorage.setItem("quote_session_id", started.data.session_id);
					localStorage.setItem("quote_session_payload", JSON.stringify(payloads));
				} catch (e) {}
				setCarQuoteList([]); // clear any stale cache so the plan page polls fresh
				clearCarPlanQuote(null);
				setLoading(false);
				navigate("/get-quote/select-car-plan");
			} else {
				// Fallback: legacy one-shot batch.
				const getQuote = await getQuotes(token, payloads);
				if (getQuote.success) {
					const errorMessages = {
						is_more_than_2_months: "You cannot renew as early as <b>60 days</b> before your expiry date.",
						is_wrong_owner: "Sorry, your car plate number does not match the given NRIC. Please try again with the correct details."
					};

					for (const [key, message] of Object.entries(errorMessages)) {
						if (getQuote?.data?.[key]) {
							setLoading(false);
							showErrorMessage(message);
							return;
						}
					}

					setCarQuoteList(getQuote.data);
					clearCarPlanQuote(null);

					setLoading(false);
					navigate("/get-quote/select-car-plan");
				}
			}
		} catch (error) {
			showErrorMessage("Something went wrong");
			setLoading(false);
		}
	};

	return (
		<>
			{ loading && <Loader2 /> }

			<Dialog
				className="filter-modal d-flex flex-row bg-white p-4 gap-2"
				modal
				header={`Filters`}
				visible={dialogOpen}
				style={{
					borderRadius: "24px 24px 0 0",
					margin: 0,
					width: "100vw",
					overflowY: "auto",
				}}
				position={"bottom"}
				content={({ hide }) => (
					<>
						<div className="filters d-flex justify-content-center w-100">
							<Image
								className="mr-2"
								src={image}
								height={80}
								width={80}
							/>
							<div className="d-flex flex-row justify-content-center mb-4">
								<h2 className="">{dialogTitle}</h2>
								<span className="formatted-text text-center">{respMessage}</span>
							</div>
						</div>
						<Button
							className="btn-primary fw-bold"
							label={`View My Request`}
							onClick={(e) => viewMyRequest(e)}
						/>
						<Button
							className="btn-secondary fw-bold"
							label={`Back to Home`}
							onClick={(e) => handleBackButton(e)}
						/>
					</>
				)}
			></Dialog>

			<div className="select-variant-container">
				{/* Title Section */}
				<div className="title-section">
					<h3 className="mb-0">{`Kindly confirm your vehicle details`}</h3>
				</div>

				{/* Owner's Info Card */}
				<div className="owner-info">
					<div className="card">
						<h4 className="owner-info-title mt-2">Owner's Info</h4>
						<div className="owner-info-row">
							<span>{getVehicleInfo?.id_type === "business" ? "Company Name" : "Owner Name (As per ID)"}</span>
							<strong>{getVehicleInfo?.id_type === "business" ? getVehicleInfo?.companyName : getVehicleInfo?.owner_name}</strong>
						</div>
						<div className="owner-info-row">
							<span>{t(`common.vehicleRegistrationNo`)}</span>
							<strong>{getVehicleInfo?.reg_no}</strong>
						</div>
						<div className="owner-info-row">
							<span>{t(`common.vehicleModel`)}</span>
							<strong>{getVehicleInfo?.vehicle}</strong>
						</div>
						<div className="owner-info-row">
							<span>
							{"Next Coverage Period"}
							</span>
							<strong>
								{formatDate(getVehicleInfo?.effective_date)}
								<br />
								- {formatDate(getVehicleInfo?.expiry_date)}
							</strong>
						</div>
					</div>
				</div>

				{/* Variant Dropdown */}
				<div className="variant-selection mt-4">
					<label
						htmlFor="variantDropdown"
						className="mb-2 d-block font-weight-bold"
					>
						<strong>{t(`autoInsurance.selectCarVariant.variant`)}</strong>
					</label>
					<Dropdown
						id="variantDropdown"
						value={selectedVariant}
						options={variants?.map((variant) => ({
						label: `${variant?.variant_name} ${variant?.variant_transmission} (${variant.variant_capacity}cc)`,
						value: variant,
						}))}
						onChange={(e) => setSelectedVariant(e.value)}
						placeholder={t(`autoInsurance.selectCarVariant.selectCarVariant`)}
						className="w-100"
          />
        </div>
        <div
							className="addon-item"
						>
            <label
              htmlFor={`recon`}
              className="addon-details"
            >
              Is Reconditioned?
            </label>
            <Checkbox
              inputId={`recon`}
              checked={isRecon}
              onChange={(e) => handleCheckboxChange(e)}
  					/>
  				</div>

				{bmkData && (bmkData.success ? (
				<div className="owner-info mt-4">
					<div className="card">
					<h4 className="owner-info-title mt-2">Butiran Maklumat Kenderaan (BMK):</h4>
					<div className="owner-info-row p-0">
						<span>Address 1</span>
						<strong>{bmkData.address1}</strong>
					</div>
					{bmkData.address2 && (
						<div className="owner-info-row p-0">
						<span>Address 2</span>
						<strong>{bmkData.address2}</strong>
						</div>
					)}
					{bmkData.address3 && (
						<div className="owner-info-row p-0">
						<span>Address 3</span>
						<strong>{bmkData.address3}</strong>
						</div>
					)}
					{bmkData.address4 && (
						<div className="owner-info-row p-0">
						<span>Address 4</span>
						<strong className="flex-shrink-0">{bmkData.address4}</strong>
						</div>
					)}
					{bmkData.address5 && (
						<div className="owner-info-row p-0">
						<span>Address 5</span>
						<strong>{bmkData.address5}</strong>
						</div>
					)}
					<div className="mt-1 mb-1 border-bottom-1"></div>
					<div className="owner-info-row p-0">
						<span>Postcode</span>
						<strong>{bmkData.postcode || ''}</strong>
					</div>
					<div className="owner-info-row p-0">
						<span>City</span>
						<strong>{bmkData.city}</strong>
					</div>
					<div className="owner-info-row p-0">
						<span className="flex-shrink-0">State</span>
						<strong className="flex-shrink-0">{bmkData.state}</strong>
					</div>
					<div className="mt-1 mb-1 border-bottom-1"></div>
					<div className="owner-info-row p-0">
						<span>Make (Brand)</span>
						<strong>{bmkData.make}</strong>
					</div>
					<div className="owner-info-row p-0">
						<span>Model</span>
						<strong>{bmkData.model}</strong>
					</div>
					<div className="owner-info-row p-0">
						<span>Model Year</span>
						<strong>{bmkData.model_year}</strong>
					</div>
					<div className="owner-info-row p-0">
						<span>Engine Capacity</span>
						<strong>{bmkData.engine_capacity}</strong>
					</div>
					</div>
				</div>
				): (
				<div className="owner-info mt-4">
					<div className="card">
					<h4 className="owner-info-title mt-2">Butiran Maklumat Kenderaan (BMK):</h4>
					<div>
						<strong className="text-left">{bmkData.error_message ? bmkData.error_message : "Vehicle Number Not Matched"}</strong>
					</div>
					<div>
						<strong className="text-left">Please contact ANSA Digital Sdn Bhd customer support at <a href="tel:+03-27795998">03-27795998</a> or email to <a href='mailto:contactus@ansa.my'>contactus@ansa.my</a>.</strong>
					</div>
					</div>
				</div>
				))}

				{/* Proceed Button */}
				<div className="button-container">
					<Button
						label={`${t("common.proceed")} (1/5)`}
						onClick={(e) => {
						submitSelectedVariant(e);
						}}
						disabled={!selectedVariant}
						className="btn-primary"
						loading={loading}
					/>
				</div>

				{/* BottomMessagePopUp Component */}
				<BottomMessagePopUp
					message={message}
					type="error"
					isVisible={isMessageVisible}
					onClose={() => setIsMessageVisible(false)}
				/>
			</div>
			</>
		);
};

export default SelectCarVariant;
